import { InvitationsServiceManagerProvider } from '../../Services/Invitations/InvitationsService';
import { composeProviders } from './composerProvider';
import { JustifyIncidenceProvider } from './justifyIncidence/JustifyIncidenceContext';
import { EmployeeManagementFilterProvider } from './queries/EmployeeManagementFilterContext';
import { SendIncidencesFilterProvider } from './SendIncidences/SendIncidencesFilterContext';

const Providers = composeProviders(
	SendIncidencesFilterProvider,
	EmployeeManagementFilterProvider,
	InvitationsServiceManagerProvider,
	JustifyIncidenceProvider
);

export default Providers;
